import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {YesNoModal} from "../elements/YesNoModal";

export class DeleteInvitationModal extends Component {
    constructor(props) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete () {
        // `clientId` opcional (tab Portal): baja per-cliente de una invitación multi —
        // quitarla acá no mata el acceso pendiente a los otros clientes de la invitación.
        const clientParam = this.props.clientId ? `?client_id=${encodeURIComponent(this.props.clientId)}` : '';
        new APIClient(API_URL + `invitation/${this.props.invitationId}/delete${clientParam}`).call('DELETE').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.props.removeDeletedInvitation(this.props.invitationId);
        })
    }

    render() {
        return <YesNoModal onYesAnswer={this.handleDelete}
                           title="Estas a punto de eliminar una invitación"
                           message=""
                           question="¿Estás seguro?"
                           buttonClassName={""}
                           buttonText={""}
                           buttonIconName={"trash"}
        />
    }
}

